import api from './api';
import types from './mutation-types';

export default {
	async getCommCodeDetails_({ commit }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodeDetails(codeType);
			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key, value: body.resultList });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	postSearchSelectList_({ commit }) {
		return api
			.postSearchSelectList()
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'carScnList',
						value: data !== null && data !== undefined ? data.body.CAR_SCN : null
					});

					commit(types.DEFAULT_ASSIGN, {
						key: 'pacScnList',
						value: data !== null && data !== undefined ? data.body.PAC_SCN : null
					});

					commit(types.DEFAULT_ASSIGN, {
						key: 'partTypeList',
						value: data !== null && data !== undefined ? data.body.PART_G : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'plntCdList',
						value: data !== null && data !== undefined ? data.body.PLNT_CD : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'flclSpcList',
						value: data !== null && data !== undefined ? data.body.FLCL_SPC : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'saleNatList',
						value: data !== null && data !== undefined ? data.body.SALE_NAT : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'occuRegnList',
						value: data !== null && data !== undefined ? data.body.OCCU_REGN : null
					});
					// commit(types.DEFAULT_ASSIGN, {
					// 	key: 'carTypeNmList',
					// 	value: data !== null && data !== undefined ? data.body.CAR_TYPE_NM : null
					// });
					commit(types.DEFAULT_ASSIGN, {
						key: 'srchScnList',
						value: data !== null && data !== undefined ? data.body.SRCH_SCN : null
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}
				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	getCarSalesList_({ commit, state }) {
		const { searchParams } = state;
		return api
			.getSaleList({ searchParams: searchParams })
			.then(data => {
				if (data.header.code === 0) {
					//그리드 조회 상태업데이트
					commit(types.DEFAULT_ASSIGN, {
						key: 'grdSalesList',
						value: data !== null && data !== undefined ? data.body.resultList : null
					});

					//roList 화면 id 조회
					commit(types.DEFAULT_ASSIGN, {
						key: 'pcRoListScrId',
						value: data.body.pcRoListScrId || ''
					});
					// 화면 PMC판매정보 id 조회
					commit(types.DEFAULT_ASSIGN, {
						key: 'pmcSaleListScrId',
						value: data.body.pmcSaleListScrId || ''
					});

					// 바스택 조회 상태업데이트
					commit(types.DEFAULT_ASSIGN, {
						key: 'graphBarStackChartInfo',
						value: data !== null && data !== undefined ? data.body.barList : null
					});

					//bar차트 Y축값 설정 추가
					if (data.body.barList !== null && data.body.barList.length > 0) {
						commit(types.DEFAULT_ASSIGN, {
							key: 'bcMaxVal',
							value: data !== null && data !== undefined ? data.body.barList[0].bcMaxVal : null
						});
					}

					// 리스트 그래프 조회 상태업데이트
					commit(types.DEFAULT_ASSIGN, {
						key: 'graphLineChartInfo',
						value: data !== null && data !== undefined ? data.body.lineList : null
					});

					// 리스트 라인차트 Y축값 설정 추가
					if (data.body.lineList !== null && data.body.lineList.length > 0) {
						commit(types.DEFAULT_ASSIGN, {
							key: 'lcMaxVal',
							value: data.body.lineList !== null && data.body.lineList !== undefined ? data.body.lineList[0].lcMaxVal : null
						});
					}

					// 그래프 로딩시작 추가
					commit(types.DEFAULT_ASSIGN, {
						key: 'isLoading',
						value: true
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
};
